import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useGetManagedGroupsQuery } from "../../api/managementApi";
import ManagedGroupCard from "./components/ManagedGroupCard";
import ManagedGroupCardSkeleton from "./components/ManagedGroupCardSkeleton";
import ManagedGroupListEmpty from "./components/ManagedGroupListEmpty";
import CreateGroupModal from "./components/CreateGroupModal";
import { useToast } from "../../components/ui/Toast";
import ConnectionState from "../../components/ui/ConnectionState";

export default function ManagedGroupListPage() {
  const { t } = useScriptMode();
  const navigate = useNavigate();
  const toast = useToast();
  const { data, isLoading, isFetching, isError, error, refetch } = useGetManagedGroupsQuery();
  const groups = data?.data?.groups || [];

  const [createOpen, setCreateOpen] = useState(false);

  const handleCreated = (groupId) => {
    toast.success(t("manage_create_success"));
    if (groupId) navigate(`/uygulama/yonetim/${groupId}`);
  };

  return (
    <div className="max-w-6xl mx-auto flex flex-col gap-6 px-4 md:px-0">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="text-3xl font-Bold text-terakkiPrimary">
          {t("manage_title")}
        </h1>
        <div className="flex items-center gap-2">
          <Button
            variant="text"
            onClick={() => navigate("/uygulama/hatim-yonetim")}
          >
            {t("hatim_mgmt_link")}
          </Button>
          <Button variant="contained" onClick={() => setCreateOpen(true)}>
            {t("manage_create_cta")}
          </Button>
        </div>
      </div>

      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          <ManagedGroupCardSkeleton />
          <ManagedGroupCardSkeleton />
          <ManagedGroupCardSkeleton />
        </div>
      ) : isError ? (
        <ConnectionState
          error={error}
          onRetry={refetch}
          retrying={isFetching}
          message={t("manage_load_error")}
        />
      ) : groups.length === 0 ? (
        <ManagedGroupListEmpty onCreate={() => setCreateOpen(true)} />
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {groups.map((g, i) => (
            <ManagedGroupCard
              key={g.id}
              group={g}
              index={i}
              onClick={(id) => navigate(`/uygulama/yonetim/${id}`)}
            />
          ))}
        </div>
      )}

      <CreateGroupModal
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        onCreated={handleCreated}
      />
    </div>
  );
}
